import { render, staticRenderFns } from "./ticket-form.vue?vue&type=template&id=66b63605&"
import script from "./ticket-form.vue?vue&type=script&lang=js&"
export * from "./ticket-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports